import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppWarningsCenter } from '../../components/AppWarningsCenter/AppWarningsCenter';
import { PATHS } from '../../config/consts';
import { getAccessTokenSelector, getResendEmail } from '../../modules/auth/selectors';
import { isSiteVersionWarningDisplayed } from '../../modules/common/selectors';
import { getCurrentUserSelector } from '../../modules/user/selectors';
import { useOryUserLogged } from '../../ory/hooks/oryUser/useOryUserLogged';
import { LoginFlowsWrapper } from '../_components/LoginFlowsWrapper/LoginFlowsWrapper';
import { LoginFormWrapper } from './components/LoginForm';
import { MFAForm } from './components/MFAForm/MFAForm';
import { MFARecoveryForm } from './components/MFARecoveryForm';
import { ICurrentUserLogin, LoginPageStep, useLoginPage } from './hook/useLoginPage';
import useLoginQueryParams from './hook/useLoginSsoQueryParams';
import { styles } from './style';
import { useSetAccessToken } from './useSetAccessToken';

export function LoginPage() {
  const [loginPageStep, setLoginPageStep] = useState<LoginPageStep>(LoginPageStep.Login);
  const accessToken = useSelector(getAccessTokenSelector);
  const isAlertShown = useSelector(isSiteVersionWarningDisplayed);
  const { isSSOLogin } = useLoginQueryParams();

  useSetAccessToken();

  const currentUser = useSelector(getCurrentUserSelector) as ICurrentUserLogin;
  const resendEmail = useSelector(getResendEmail);
  const { isOryUserLoggedIn, oryLoginStatus } = useOryUserLogged({ accessToken, currentUser, isSSOLogin });
  const { getTitle, navigate, redirectToAppWhenUserIsLoggedIn } = useLoginPage({
    currentUser,
    isOryUserLoggedIn,
  });

  useEffect(() => {
    redirectToAppWhenUserIsLoggedIn();
  }, [currentUser.id, oryLoginStatus]);

  useEffect(() => {
    if ((resendEmail?.length ?? 0) > 0) {
      navigate(PATHS.RESEND);
    }
  }, [resendEmail]);

  return (
    <>
      <AppWarningsCenter />
      <Box sx={{ ...(isAlertShown && styles.alert), backgroundColor: 'background.paper' }}>
        <LoginFlowsWrapper title={getTitle(loginPageStep)}>
          {loginPageStep === LoginPageStep.Login && (
            <LoginFormWrapper
              onOrySecondFactor={() => {
                setLoginPageStep(LoginPageStep.MFA);
              }}
            />
          )}
          {loginPageStep === LoginPageStep.MFA && (
            <MFAForm
              onMFARecovery={() => {
                setLoginPageStep(LoginPageStep.MFARecovery);
              }}
            />
          )}
          {loginPageStep === LoginPageStep.MFARecovery && (
            <MFARecoveryForm
              onBack={() => {
                setLoginPageStep(LoginPageStep.MFA);
              }}
            />
          )}
        </LoginFlowsWrapper>
      </Box>
    </>
  );
}
